import { getApiToken, refreshApiToken } from '../api/authApiClient';
const MERCURY = '1KAV4fFiYOc3dPNCwzeT';
// Bearer credentials travel only in the encrypted socket's first auth frame,
// never query strings, subprotocol names, rendered UI or logs.
export async function respondToMercurySocketChallenge(socket, tenantId, message) {
  if (tenantId !== MERCURY || message?.type !== 'authentication_required') return false;
  try {
    if (typeof socket.url !== 'string' || new URL(socket.url).protocol !== 'wss:') {
      if (socket.readyState === 1) socket.close(1008, 'Access unavailable');
      return true;
    }
    const token = await refreshApiToken() || getApiToken();
    if (!token || socket.readyState !== 1) {
      if (socket.readyState === 1) socket.close(1008, 'Access unavailable');
      return true;
    }
    socket.send(JSON.stringify({ type: 'authenticate', token }));
  } catch (_) {
    if (socket.readyState === 1) socket.close(1008, 'Access unavailable');
  }
  return true;
}
